<!-- The toolbar lives in `ft-text-html-editor`, ONE per editor group rather than one per field.
     It used to be here, and with a multi-field group (Share Message is header + homepageHeader)
     that rendered a toolbar per editor, all of them absolutely positioned at the container's top
     — measured stacked on the same 199x42 rect. Only the focused editor's toolbar took `.ql-active`,
     and the one painted on top was whichever came LAST in the DOM, so pressing Bold in the first
     field highlighted a button nobody could see and washed the visible one out through the dimmed
     duplicate. See `text-html-editor.component.html` for the single toolbar that replaced them. -->
<div class="ql-container ql-snow">
    <div #editable
         class="ql-editor"
         [class.ql-blank]="isBlank"
         [attr.contenteditable]="disabled ? 'false' : 'true'"
         [attr.data-placeholder]="placeholder"
         (input)="onInput()"
         (paste)="onPaste($event)"
         (keyup)="syncSelection()"
         (mouseup)="syncSelection()"
         (focus)="onEditableFocus()"
         (blur)="onEditableBlur()"></div>
</div>
